module.exports = __webpack_public_path__ + "static/instruments-08b378f3315afdf7b14cf9ba5d03973a.png";